import React, { useState } from 'react';
import { 
  FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaCheckCircle, 
  FaChevronDown, FaPaperPlane, FaUser, FaCommentAlt 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const ContactUs = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  // State for Contact Form inputs
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    comment: ''
  });

  // State for form submission status
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate form submission delay
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', comment: '' });
    }, 1200);
  };

  const faqs = [
    {
      q: "How quickly will your team respond to my inquiry?",
      a: "Our advisory team typically responds to all website inquiries and consultation requests within 24 business hours. For urgent matters, you can reach our Hyderabad office directly via phone."
    },
    {
      q: "Where is Lotoswealth's office located?",
      a: "Our primary advisory headquarters is located in Hyderabad, Telangana, India. We host clients both in-person at our office and virtually via secure video conferences for NRIs and clients across the globe."
    },
    {
      q: "Is my personal and financial information secure when I submit the form?",
      a: "Yes. We adhere to strict data privacy and confidentiality standards. Your personal and financial details are used solely to facilitate your consultation and are never shared with third parties."
    },
    {
      q: "Are initial consultations free of charge?",
      a: "Yes! Your initial introductory consultation with our wealth and tax advisors is completely complimentary. We discuss your financial goals and outline how we can assist you before any commitment is made."
    }
  ];

  return (
    <main className="contact-us-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Contact Lotoswealth | Wealth Management & Financial Advisors in Hyderabad</title>

  <meta
    name="description"
    content="Contact Lotoswealth in Hyderabad for expert Wealth Management, Portfolio Management Services (PMS), Financial Planning, Tax Planning, Mutual Funds, Stock Investments, Retirement Planning, Home Loans, Car Loans, Education Loans, and personalized financial advisory services."
  />

  <meta
    name="keywords"
    content="Contact Lotoswealth, Contact Wealth Management Hyderabad, Financial Advisor Hyderabad, Investment Advisor Hyderabad, Wealth Advisor Hyderabad, Portfolio Management Services Hyderabad, PMS Hyderabad, Financial Planning Hyderabad, Tax Planning Hyderabad, Mutual Funds Hyderabad, Stock Investment Hyderabad, Retirement Planning Hyderabad, Asset Management Hyderabad, Home Loan Hyderabad, Car Loan Hyderabad, Education Loan Hyderabad, Financial Services Hyderabad, Wealth Management Hyderabad, Lotoswealth Hyderabad"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/contact-us"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/contact-us"
  />
  <meta
    property="og:title"
    content="Contact Lotoswealth | Financial Advisors in Hyderabad"
  />
  <meta
    property="og:description"
    content="Get in touch with Lotoswealth for expert Wealth Management, Financial Planning, Investment Advisory, Portfolio Management Services, Mutual Funds, Tax Planning, and Loan Assistance in Hyderabad."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Contact Lotoswealth | Financial Advisors in Hyderabad"
  />
  <meta
    name="twitter:description"
    content="Speak with our financial experts in Hyderabad for Wealth Management, Investment Planning, Mutual Funds, PMS, Tax Planning, Retirement Planning, and Loan Advisory."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/contact-us.jpg" 
            alt="Contact Lotoswealth" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Contact Lotoswealth
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Let’s Discuss Your Financial Future & Wealth Strategy
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Whether you have questions about private equity, tax optimization, retirement planning, or portfolio management, our senior advisors are ready to provide expert guidance tailored to your goals.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Reach out to us using the contact form below or visit our Hyderabad office. We look forward to partnering with you on your journey to lifelong financial security.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. CONTACT FORM & INFO SECTION (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row g-5 align-items-center">
            
            {/* Contact Info Column */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">Get in Touch With Us</h2>
              <p className="text-muted line-height-lg mb-4">
                Have questions or ready to schedule your complimentary consultation? Contact our team directly or fill out the form, and we will get back to you promptly.
              </p>

              <div className="d-flex flex-column gap-4">
                <div className="d-flex align-items-start gap-3">
                  <div className="bg-white p-3 rounded-circle shadow-sm text-teal flex-shrink-0">
                    <FaMapMarkerAlt size={20} />
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-1">Our Headquarters</h5>
                    <p className="text-muted small mb-0">Hyderabad, Telangana, India</p>
                  </div>
                </div>

                <div className="d-flex align-items-start gap-3">
                  <div className="bg-white p-3 rounded-circle shadow-sm text-teal flex-shrink-0">
                    <FaPhoneAlt size={20} />
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-1">Phone Number</h5>
                    <p className="text-muted small mb-0">+91 889 786 6074</p>
                  </div>
                </div>

                <div className="d-flex align-items-start gap-3">
                  <div className="bg-white p-3 rounded-circle shadow-sm text-teal flex-shrink-0">
                    <FaEnvelope size={20} />
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-1">Email Address</h5>
                    <p className="text-muted small mb-0">support@lotoswealth.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Column */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 p-md-5 bg-white rounded-4 shadow-sm border-top border-teal border-5">
                <h3 className="fw-bold text-dark mb-3">Send Us a Message</h3>
                <p className="text-muted small mb-4">Fill out the form below and our advisors will connect with you shortly.</p>

                {submitted ? (
                  <div className="text-center py-5">
                    <div className="text-success mb-3">
                      <FaCheckCircle size={50} />
                    </div>
                    <h4 className="fw-bold text-dark mb-2">Thank You!</h4>
                    <p className="text-muted small mb-4">Your message has been received successfully. One of our senior wealth advisors will reach out to you within 24 hours.</p>
                    <button 
                      className="btn btn-outline-teal btn-sm fw-bold px-4 py-2"
                      onClick={() => setSubmitted(false)}
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      
                      <div className="col-md-6">
                        <label className="form-label small fw-bold text-dark">Your Name *</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light text-muted"><FaUser size={14} /></span>
                          <input 
                            type="text" 
                            name="name" 
                            className="form-control" 
                            placeholder="Enter your full name" 
                            value={formData.name} 
                            onChange={handleChange} 
                            required 
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label small fw-bold text-dark">Email Address *</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light text-muted"><FaEnvelope size={14} /></span>
                          <input 
                            type="email" 
                            name="email" 
                            className="form-control" 
                            placeholder="name@example.com" 
                            value={formData.email} 
                            onChange={handleChange} 
                            required 
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <label className="form-label small fw-bold text-dark">Phone Number *</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light text-muted"><FaPhoneAlt size={14} /></span>
                          <input 
                            type="tel" 
                            name="phone" 
                            className="form-control" 
                            placeholder="+91 XXXXX XXXXX" 
                            value={formData.phone} 
                            onChange={handleChange} 
                            required 
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <label className="form-label small fw-bold text-dark">Comment / Message *</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light text-muted align-items-start pt-2"><FaCommentAlt size={14} /></span>
                          <textarea 
                            name="comment" 
                            className="form-control" 
                            rows="4" 
                            placeholder="Tell us about your financial goals or queries..." 
                            value={formData.comment} 
                            onChange={handleChange} 
                            required 
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-12 mt-4">
                        <button 
                          type="submit" 
                          className="btn-custom-teal hover-lift w-100 py-3 fs-6 border-0 rounded text-white shadow d-flex align-items-center justify-content-center gap-2 fw-bold"
                          disabled={loading}
                        >
                          {loading ? (
                            <span>Sending Message...</span>
                          ) : (
                            <>
                              <FaPaperPlane size={14} /> Submit Message
                            </>
                          )}
                        </button>
                      </div>

                    </div>
                  </form>
                )}

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          3. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding consultations & reaching out</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
};

export default ContactUs;